import SVGLoader from '@src/components/svg/SVGLoader'
import styled from '@emotion/styled'

type PropsType = {
	sampleProof: string
	onCancelImg?: () => void
}
const SampleProofFormItem = ({ sampleProof, onCancelImg }: PropsType) => {
	return (
		<ItemWrapper>
			<CancelIconWrapper
				onClick={() => {
					if (onCancelImg) onCancelImg()
				}}
			>
				<SVGLoader name="closeIcon" />
			</CancelIconWrapper>
			<ImgTag src={sampleProof} alt="상품 설명" />
		</ItemWrapper>
	)
}

const ItemWrapper = styled.div`
	position: relative;
	width: 30rem;
`
const CancelIconWrapper = styled.button`
	position: absolute;
	top: 1rem;
	right: 1rem;
	color: #7f7f7f;
	width: 1.8rem;
	height: 1.8rem;
	border-radius: 100%;
	background: #eaeaea;
	padding: 0.6rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
`
const ImgTag = styled.img`
	width: 100%;
	max-width: 100%;
`
export default SampleProofFormItem
